import { IAppUserContext } from '@truckdown/components-systems';
import context, { IInitializer, IUserContext } from "@truckdown/systems";
import fleetUpgrade from './FleetUpgrade.vue';
import members from './Members/Members.vue';
import duplicateAccounts from './DuplicateAccounts/DuplicateAccounts.vue';
import users from './Users/Users.vue';
import userList from './Users/UserList/UserList.vue';
import userProfile from './Users/UserProfile/UserProfile.vue';
import integrations from './Integrations/Integrations.vue';
import companyInformation from './CompanyInformation/CompanyInformation.vue';
import editAccountAdmin from './EditAccountAdmin/EditAccountAdmin.vue';
import statusMessage from './StatusMessage/StatusMessage.vue';
import timeZoneLookup from './TimeZoneLookup/TimeZoneLookup.vue';

class ComponentInitializer implements IInitializer {
    name: string = 'ComponentInitializer';
    order: number = 0;

    initialize(context: IUserContext): Promise<void> {
        let app = (context as IAppUserContext).app;

        app.component('fleet-upgrade', fleetUpgrade);
        app.component('members', members);
        app.component('duplicate-accounts', duplicateAccounts);
        app.component('users', users);
        app.component('user-list', userList);
        app.component('user-profile', userProfile);
        app.component('integrations', integrations);
        app.component('company-information', companyInformation);
        app.component('edit-account-admin', editAccountAdmin);
        app.component('status-message', statusMessage);
        app.component('timezone-lookup', timeZoneLookup);

        return Promise.resolve();
    }
}

context.registerService({
    name: 'IInitializer',
    activator: async () => {
        return new ComponentInitializer();
    }
});
